<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> جستجو درخواست ها </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->
    
    <form class="row gx-0 gy-2 p-0 m-0" [formGroup]="mdl_Search">
        
        <!-- از تاریخ -->
    
        <div class="col-12 col-md-2 p-1 position-relative">
    
            <label> از تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- تا تاریخ -->
    
        <div class="col-12 col-md-2 p-1 position-relative">
    
            <label> تا تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strEDate" placeholder="تا تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- موضوع -->

        <div class="col-12 col-md-2 p-1 position-relative">

            <label class="mb-2 text-muted"> موضوع </label>

            <select class="form-select" formControlName="tiMadonik_RequestType">

                <option class="text-center" value="-1"> &nbsp; انتخاب کنید &nbsp; </option>

                <option class="text-center" *ngFor="let item of lst_RequestType" [value]="item.tiMadonik_RequestType">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- مدرسه -->

        <div class="col-12 col-md-2 p-1 position-relative">

            <label class="mb-2 text-muted"> مدرسه </label>

            <select class="form-select" formControlName="iMobileDomain">

                <option class="text-center" value="-1"> &nbsp; انتخاب کنید &nbsp; </option>

                <option class="text-center" *ngFor="let item of lst_MobileDomain" [value]="item.iMobileDomain">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- کد رهگیری -->

        <div class="col-12 col-md-2 p-1 position-relative">

            <label class="mb-2 text-muted"> کد رهگیری</label>

            <input class="form-control text-center" formControlName="iMadonik_Request">

        </div>

        <!-- کد ملی -->

        <div class="col-12 col-md-2 p-1 position-relative">

            <label class="mb-2 text-muted"> کد ملی</label>

            <input class="form-control text-center" formControlName="strNationalID" maxlength="10">

        </div>

        <!-- موبایل -->

        <div class="col-12 col-md-2 p-1 position-relative">

            <label class="mb-2 text-muted"> موبایل</label>

            <input class="form-control text-center" formControlName="strMobile" maxlength="11">

        </div>

         <!-- جستجو -->

        <div class="col-12 col-md-auto p-1">

            <div class="w-100 h-100">

                <button class="btn btn-primary w-100" (click)="searchRequest()">

                    جستجو

                </button>

            </div>

        </div>

         <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto p-1">

            <div class="w-100 h-100">

                <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')">

                    خروجی اکسل

                </button>

            </div>

        </div>

    </form>

    <!-- اطلاعات -->

    <div class="border border-2 mt-2 p-2">

        <div class="row gx-0 gy-0 p-0 m-0">

            <div class="col-12 p-1">

                <div class="w-100 h-100">

                    <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

                </div>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 273px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                 <thead class="">

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1" > عملیات </th>

                        <th class="text-center col-1" > شماره </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> ساعت </th>

                        <th class="text-center"> وضعیت </th>

                        <th class="text-center"> دانش آموز </th>

                        <th class="text-center"> موضوع </th>

                    </tr>

                </thead>

                <tbody class="">

                    <tr class="col-12 text-center" *ngFor="let item of lst_Requests; let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="text-center pointer" (click)="openRequest(item)">  
                            
                            <i class="fa fa-info-circle fa-lg"></i>
                        
                        </td>

                        <td> {{ item.iMadonik_Request | faNum}} </td>

                        <td> {{ item.strDate | faNum}} </td>

                        <td> {{ item.strTime | faNum}} </td>

                        <td> {{ item.strMadonik_RequestStatus_strComment }} </td>

                        <td> {{ item.strPassenger_FullName }} </td>

                        <td> {{ item.strMadonik_RequestType_strComment }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade dir" id="detail_Modal" tabindex="4" role="dialog" aria-hidden="true">

    <div class="modal-dialog modal-lg modal-dialog-centered">

        <div class="modal-content bg-gray-soft">

            <div class="modal-header">

                <button type="button" class="btn-close m-0 p-0" data-bs-dismiss="modal" aria-label="Close"></button>

                <h5 class="modal-title mb-0" id=""> مشاهده درخواست </h5>

            </div>

            <div class="modal-body" style="direction: rtl;">

                <div class="row gx-0 gy-0 p-1 m-0">

                    <div class="col-7 p-1">

                        <div class="w-100 h-100">

                            <p class="border-bottom mb-2 pb-2">

                                <span class="text-muted"> شماره درخواست : </span>

                                <strong class=""> {{ objRequest.iMadonik_Request | faNum }} </strong>

                            </p>

                            <p class="border-bottom mb-2 pb-2">

                                <span class="text-muted"> عنوان : </span>

                                <strong class="">

                                    <small> {{ objRequest.strMadonik_RequestType_strComment }} </small>

                                </strong>

                            </p>

                            <p class="border-bottom mb-2 pb-2">

                                <span class="text-muted"> تاریخ : </span>

                                <strong class="">

                                    <small> {{ objRequest.strTime | faNum }} </small>

                                    <small> - {{ objRequest.strDate | faNum }} </small>

                                </strong>

                            </p>

                            <p class="border-bottom mb-2 pb-2">

                                <span class="text-muted"> دانش آموز : </span>

                                <strong class="">

                                    <small> {{ objRequest.strPassenger_FullName | faNum }} </small>

                                </strong>

                            </p>

                            <p class="border-bottom mb-2 pb-2">

                                <span class="text-muted"> وضعیت : </span>

                                <strong [class.text-success]="objRequest.tiMadonik_RequestStatus == 0" [class.text-primary]="objRequest.tiMadonik_RequestStatus == 1" [class.text-info]="objRequest.tiMadonik_RequestStatus == 2">

                                    {{ objRequest.strMadonik_RequestStatus_strComment }}

                                </strong>

                            </p>

                            <p *ngIf="objRequest.strDetail" class="mb-2 pb-2">

                                <span class="text-muted"> توضیحات : </span>

                                <strong class=""> {{ objRequest.strDetail }} </strong>

                            </p>

                            <div *ngIf="objRequest?.strVoice" class="w-100 voice-container">

                                <audio controls class="w-100 rounded" style="background: #F1F3F4;">

                                    <source type="audio/mp3" src="data:audio/mp3;base64,{{objRequest.strVoice}}">

                                </audio>

                            </div>

                            <div class="w-100 p-1">

                                <ng-container *ngIf="objRequest.fLat !== 0">

                                    <button class="btn btn-warning ms-2" (click)="openMap(objRequest)">
    
                                        <small> موقعیت </small>
    
                                    </button>

                                </ng-container>

                                <ng-container *ngIf="(objRequest.tiMadonik_RequestStatus >=2 && objRequest.tiMadonik_RequestStatus <=5) || objRequest.tiMadonik_RequestStatus == 10">

                                    <button class="btn btn-info ms-2" (click)="openProceedings()">

                                        <small> &nbsp; اقدامات &nbsp; </small>

                                    </button>

                                </ng-container>

                            </div>

                        </div>

                    </div>

                    <div class="col-5 p-1">

                        <div class="w-100 request-image-container">

                            <img [src]="objRequest.strImage ? 'data:image/jpeg;base64,' + objRequest.strImage : '../../../assets/Img/preview__thumbnail.png' " [alt]="objRequest.strMadonik_RequestType_strComment">

                        </div>

                    </div>

                </div>

            </div>

            <div class="modal-footer ">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal"> بستن </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade dir" id="Proceedings_Modal" tabindex="5" role="dialog" aria-hidden="true">

    <div class="modal-dialog modal-lg ">

        <div class="modal-content bg-gray-soft">

            <div class="modal-header">

                <button type="button" class="btn-close m-0 p-0" data-bs-dismiss="modal" aria-label="Close"></button>

                <h5 class="modal-title mb-0" id=""> اقدامات </h5>

            </div>

            <div class="modal-body" style="direction: rtl;">

                <div class="row w-100 gx-0 gy-1">

                    <div *ngFor="let item of lst_Proceedings" class="col-12 col-md-6 p-1 pointer">

                        <div class="w-100 h-100 d-flex border border-2 p-2">

                            <div class="col-4 image-container p-1">

                                <img [src]="item.strImage ? 'data:image/jpeg;base64,' + item.strImage : '../../../assets/Img/preview__thumbnail.png' " [alt]="item.strMadonik_RequestType_strComment">

                            </div>

                            <div class="col-8 p-2">

                                <p class="border-bottom mb-1 pb-2">

                                    <span class="text-muted"> کد  : </span>

                                    <strong class=""> {{ item.iMadonik_Proceedings | faNum }} </strong>

                                </p>

                                <p class="border-bottom mb-1 pb-2">

                                    <span class="text-muted"> تاریخ : </span>

                                    <strong class="">

                                        <small> {{ item.strDateTime | faNum }} </small>

                                    </strong>

                                </p>

                                <p class="border-bottom mb-1 pb-2">

                                    <span class="text-muted"> اقدام کننده : </span>

                                    <strong class="">

                                        <small> {{ item.strFullName }} </small>

                                    </strong>

                                </p>

                                <p *ngIf="item.strActionDescription" class="border-bottom mb-1 pb-2">

                                    <span class="text-muted"> توضیحات : </span>

                                    <strong class="">

                                        <small> {{ item.strActionDescription }} </small>

                                    </strong>

                                </p>

                            </div>

                        </div>

                    </div>

                    <div *ngIf="!lst_Proceedings.length">

                        <p class="text-center"> موردی یافت نشد! </p>

                    </div>

                </div>

            </div>

            <div class="modal-footer">
               
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal"> بستن </button>


            </div>

        </div>

    </div>

</div>

<custom-map *ngIf="showCustom_Map" 

    [strValue]="mdl_Request.get('strAddress')?.value"

    [longLat]="[mdl_Request.get('fLon')?.value,mdl_Request.get('fLat')?.value]"
    
    [isOpenModal]="true" 
    
    [isView]="true"

    [skip_Search]="true" 
    
    (mdl_Submit)="showCustom_Map=false">

</custom-map>